/**
 * DOM Setup Functions
 *
 * Component HTML generation, overlay management, hidden elements,
 * and color scheme application.
 */

import type { Puzzle } from '../core/Puzzle';

/**
 * Get the component HTML structure
 */
export function getComponentHtml(): string {
    return `<form>
    <div id="rejtveny_menusor"></div>
    <div id="rejtveny_komponens">
      <div id="rejtveny_fejlec">Töltés...</div>
      <div id="rejtveny"></div>
      <div id="rejtveny_leiras"></div>
      <div id="rejtveny_lablec">
        <div id="oszlop-0" class="oszlop2"></div>
        <div id="oszlop-1" class="oszlop2"></div>
        <div id="oszlop-2" class="oszlop2"></div>
        <div id="oszlop-3" class="oszlop2"></div>
      </div>
    </div>
    <div id="rejtveny_megoldassav"></div>
    <div id="rejtveny_meghatarozassav"></div>
    <div id="rejtveny_elozmenysav"></div>
  </form>`;
}

/**
 * Add overlay divs to the body for modals and popups.
 *
 * @param onOverlayClick - Callback invoked when user clicks an overlay (for save warning)
 */
export function addOverlayDivs(onOverlayClick?: () => void): void {
    const body = document.body;

    if (!document.getElementById('zarRejtveny')) {
        const zarRejtveny = document.createElement('div');
        zarRejtveny.id = 'zarRejtveny';
        zarRejtveny.addEventListener('mousedown', () => onOverlayClick?.());
        body.appendChild(zarRejtveny);
    }

    if (!document.getElementById('zarFixMenu')) {
        const zarFixMenu = document.createElement('div');
        zarFixMenu.id = 'zarFixMenu';
        zarFixMenu.addEventListener('mousedown', () => onOverlayClick?.());
        body.appendChild(zarFixMenu);
    }

    if (!document.getElementById('zarPopUp')) {
        const zarPopUp = document.createElement('div');
        zarPopUp.id = 'zarPopUp';
        body.appendChild(zarPopUp);
    }
}

/**
 * Show overlay divs after initialization.
 * These overlays block interactions when there are unsaved changes.
 */
export function showOverlayDivs(): void {
    const zarRejtveny = document.getElementById('zarRejtveny');
    const zarFixMenu = document.getElementById('zarFixMenu');

    if (zarRejtveny) zarRejtveny.style.display = 'block';
    if (zarFixMenu) zarFixMenu.style.display = 'block';
}

/**
 * Hide overlay divs after save
 */
export function hideOverlayDivs(): void {
    const zarRejtveny = document.getElementById('zarRejtveny');
    const zarFixMenu = document.getElementById('zarFixMenu');

    if (zarRejtveny) zarRejtveny.style.display = 'none';
    if (zarFixMenu) zarFixMenu.style.display = 'none';
}

/**
 * Add hidden elements for cell highlighting
 */
export function addHiddenElements(): void {
    const puzzleEl = document.getElementById('rejtveny');
    if (!puzzleEl) return;

    const elements = [
        { id: 'aktivmezo', html: '&nbsp;' },
        { id: 'aktivtomb', html: '&nbsp;' },
        { id: 'aktivszinkronmezo', html: '&nbsp;' },
        { id: 'rejtveny_popupmenu', html: '&nbsp;' },
    ];

    for (const { id, html } of elements) {
        if (!document.getElementById(id)) {
            const div = document.createElement('div');
            div.id = id;
            div.innerHTML = html;
            div.contentEditable = 'false';
            puzzleEl.appendChild(div);
        }
    }
}

/**
 * Apply color scheme to cells
 */
export function applyColorScheme(puzzle: Puzzle): void {
    // Apply to numbered cells
    const numberedCells = document.getElementsByClassName('számosmező');
    for (let i = 0; i < numberedCells.length; i++) {
        const cell = numberedCells[i] as HTMLElement;
        cell.style.backgroundColor = puzzle.borderColor;
        cell.style.borderColor = puzzle.borderColor;
        cell.style.color = puzzle.textColor;
    }

    // Apply to colored cells
    const coloredCells = document.getElementsByClassName('színes');
    for (let i = 0; i < coloredCells.length; i++) {
        const cell = coloredCells[i] as HTMLElement;
        cell.style.backgroundColor = puzzle.backgroundColor;
    }
}
